import React from 'react'
import { Image, Pressable, Text, View } from 'react-native'
import { tv } from 'tailwind-variants'

import { body2 } from '@ui-kit/core/typography'

import type { RadioSetComponentProps as Props } from './types'

export const radioBox = tv({
  slots: {
    container:
      'ios:border android:border mb-2.5 flex w-full flex-row items-center gap-x-2.5 rounded-md border border-grey-100 bg-grey-100 px-5 py-6 active:opacity-70',
    iconContainer: 'flex h-[30px] w-5 flex-shrink-0 flex-col items-center justify-center',
    icon: 'h-full w-full',
    textContainer: 'flex min-w-0 flex-1 flex-col gap-y-4',
    label: [body2({ weight: 'bold' }), 'leading-6'],
    subtitle: body2({ emphasis: 'medium' }),
  },
  variants: {
    isLast: {
      true: {
        container: 'mb-0',
      },
    },
    layout: {
      vertical: {},
      horizontal: {
        container: 'mb-0 w-auto flex-1 justify-center',
        textContainer: 'items-center',
      },
    },
    checked: {
      true: {
        container: 'border-deep-forest',
      },
    },
    disabled: {
      true: {
        container: 'opacity-40',
      },
    },
  },
})

const RadioBox = (props: Props) => {
  const onPress = async () => {
    if (props.disabled) {
      return
    }

    await props.onPress(props.value)
  }

  const { container, icon, iconContainer, textContainer, label, subtitle } = radioBox({
    isLast: props.isLast,
    layout: props.layout,
    checked: props.checked,
    disabled: props.disabled,
  })

  return (
    <Pressable
      className={container()}
      onPress={onPress}
      disabled={props.disabled}
      testID={props.testID}
    >
      {props.image !== undefined && (
        <View className={iconContainer()}>
          <Image className={icon()} source={props.image} resizeMode="contain" />
        </View>
      )}
      <View className={textContainer()}>
        <Text className={label()}>{props.label}</Text>
        {props.subtitle ? <Text className={subtitle()}>{props.subtitle}</Text> : null}
      </View>
    </Pressable>
  )
}

export default RadioBox
